import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAllowOnlyValidNumbers]', // ✅ Now follows Angular naming conventions
  standalone: true,
})
export class AllowOnlyValidNumbersDirective {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @HostListener('input', ['$event']) onInput(event: any) {
    const value = event?.target?.value;

    // Prevents only "00", "000", but allows "0", "101", "120"
    if (/^0{2,}$/.test(value)) {
      event.target.value = '';
    }
  }
}
